import React from 'react';

const FormSection = ({ children, columns = 2, verticalMargin = 8, horizontalMargin }) => {
  const gridColsClass = `grid-cols-${columns}`;
  const verticalMarginClass = `my-${verticalMargin}`;
  const horizontalMarginClass = `my-${horizontalMargin}`;

  return (
    <div className={`grid ${gridColsClass} gap-x-4 ${verticalMarginClass} ${horizontalMarginClass}`}>
      {children}
    </div>
  );
};

export default FormSection;
